import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  Output,
  computed,
  input,
  output,
  signal,
  viewChild,
} from '@angular/core';
import { APP } from 'src/app/config/app';
import { IServicesFilters } from 'src/app/filters';
import { IFilterPanelSelection, IFilterPanelValues } from 'src/app/models';
import { FilterType } from 'src/app/models/enums';
import { LiteralService, UtilsService } from 'src/app/services';
import { FILTER_PANEL_ADAPTERS } from 'src/app/shared/filter-panel/filterPanelAdapters';
import { images } from 'src/images';

@Component({
  selector: 'app-service-search-bar',
  templateUrl: './service-search-bar.component.html',
  styleUrl: './service-search-bar.component.scss',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class ServiceSearchBarComponent {
  @Input() placeholder = '';
  @Input() searching = false;
  @Input() searchValue = '';
  @Output() searchEventEmitter = new EventEmitter<string>();
  @Output() sort = new EventEmitter();
  readonly filters = input<IServicesFilters>();
  readonly filter = output<IServicesFilters>();

  readonly filterOpened = signal(false);
  readonly filterFields = APP.SERVICES_FILTER_FIELDS;
  readonly filterTypes = FilterType;
  readonly filterSelection = computed<IFilterPanelSelection | null>(() => {
    const filters = this.filters();
    return filters ? FILTER_PANEL_ADAPTERS[FilterType.SERVICES]!.toSelection(filters) : null;
  });
  readonly filtersApplied = computed(() => {
    const filters = this.filters();
    return filters ? this.utilsService.getFiltersCount({ ...filters, selectedTowns: [] }) : 0;
  });
  readonly filterButtonLabel = computed(() => {
    const label = this.literalService.get('filters', true);
    return this.filtersApplied() > 0 ? `${label} (${this.filtersApplied()})` : label;
  });
  private readonly filterToggle = viewChild.required<ElementRef<HTMLButtonElement>>('filterToggle');

  public sortedOpened = false;

  public images = images;

  constructor(
    public literalService: LiteralService,
    private utilsService: UtilsService,
    private elementRef: ElementRef<HTMLElement>,
  ) {}

  @HostListener('document:click', ['$event'])
  onDocumentClick(event: Event) {
    if (this.filterOpened() && !this.elementRef.nativeElement.contains(event.target as Node)) {
      this.filterOpened.set(false);
    }
  }

  search(event: any) {
    this.searchEventEmitter.emit(event);
  }

  toggleFilter() {
    this.filterOpened.update((opened) => !opened);
  }

  closeFilter() {
    this.filterOpened.set(false);
    this.filterToggle().nativeElement.focus();
  }

  onFilter(values: IFilterPanelValues) {
    this.filter.emit(FILTER_PANEL_ADAPTERS[FilterType.SERVICES]!.toFilters(values));
  }
}
